import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';

import Icon from '../../../components/AppIcon';

const PauseSubscriptionModal = ({ isOpen, onClose, onConfirm, subscription, processing }) => {
  const [selectedDuration, setSelectedDuration] = useState(1);

  const durations = [
    { months: 1, label: '1 Month', description: 'Short break' },
    { months: 2, label: '2 Months', description: 'Extended pause' },
    { months: 3, label: '3 Months', description: 'Maximum pause' }
  ];

  const handleConfirm = () => {
    onConfirm(selectedDuration);
  };

  const calculateResumeDate = (months) => {
    const date = new Date();
    date?.setMonth(date?.getMonth() + months);
    return date?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  const planName = subscription?.subscription_plans?.name || 'Free';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Pause Your Subscription"
      description="Take a break without losing your data or settings"
      type="info"
      icon="Pause"
      showCloseButton={!processing}
      closeOnOverlayClick={!processing}
      actions={
        <>
          <button
            onClick={onClose}
            disabled={processing}
            className="px-4 py-2 text-sm font-medium text-foreground hover:bg-muted rounded-lg transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={processing}
            className="px-4 py-2 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg transition-colors disabled:opacity-50"
          >
            {processing ? 'Processing...' : 'Confirm Pause'}
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="bg-blue-500/10 rounded-lg p-4 border border-blue-500/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-blue-500 flex-shrink-0 mt-0.5" />
            <div className="space-y-2">
              <p className="text-sm font-medium text-foreground">
                What happens when you pause?
              </p>
              <ul className="space-y-1 text-sm text-muted-foreground">
                <li>• Your subscription billing will be paused</li>
                <li>• All your data and settings will be retained</li>
                <li>• Your agents will be temporarily deactivated</li>
                <li>• Subscription will automatically resume after the pause period</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">Select pause duration</label>
          <div className="grid grid-cols-1 gap-2">
            {durations?.map((duration) => (
              <button
                key={duration?.months}
                onClick={() => setSelectedDuration(duration?.months)}
                className={`
                  flex items-center justify-between p-4 rounded-lg border transition-all
                  ${selectedDuration === duration?.months
                    ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
                  }
                `}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    selectedDuration === duration?.months
                      ? 'border-primary' :'border-muted-foreground'
                  }`}>
                    {selectedDuration === duration?.months && (
                      <div className="w-2.5 h-2.5 rounded-full bg-primary" />
                    )}
                  </div>
                  <div className="text-left">
                    <p className="text-sm font-medium text-foreground">{duration?.label}</p>
                    <p className="text-xs text-muted-foreground">{duration?.description}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">Resumes on</p>
                  <p className="text-sm font-medium text-foreground">{calculateResumeDate(duration?.months)}</p>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <p className="text-sm text-muted-foreground">
            <Icon name="Calendar" size={14} className="inline mr-1" />
            Your {planName} subscription will automatically resume on <strong>{calculateResumeDate(selectedDuration)}</strong>. You can resume earlier anytime from your billing settings.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default PauseSubscriptionModal;